import http from '@root/utils/axios/admin';

let state = {
    CarModelsList: [],
    CarModel: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCarModelsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/car-models', { params: filter }).then((response) => {
                commit('setCarModelsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchCarModel({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/car-models/' + id).then((response) => {
                commit('setCarModel', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

}


let mutations = {
    setCarModelsList(state, data) {
        state.CarModelsList = data;
    },
    setCarModel(state, data) {
        state.CarModel.data = data;
    },
    setCarModelLike(state, id) {
        state.CarModelsList.data.forEach(item => {
            if (item.id === id) {
                item.is_liked = true;
                item.likes_count = item.likes_count + 1;
            }
        });
    },
    setCarModelUnLike(state, id) {
        state.CarModelsList.data.forEach(item => {
            if (item.id === id) {
                item.is_liked = false;
                item.likes_count = item.likes_count - 1;
            }
        });
    },

}

export default {
    state,
    actions,
    mutations
}